// extracted by mini-css-extract-plugin
export default {"productBoxTitle":"WLKONh","productBox":"aAnLJj"};